import React from 'react';
import { Card } from 'antd';
import RagQualitySection from './sections/RagQualitySection';
import FeedbackSection from './sections/FeedbackSection';

export default function DashboardResponseQuality() {
  return (
    <>
      <RagQualitySection />
      <Card className="modern-card" title={<span className="card-title">User feedback</span>} style={{ marginTop: 20 }}>
        <FeedbackSection />
      </Card>
    </>
  );
}
